import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { LAUNCH_PLAN_ID } from "../data/products.js";

const CartContext = createContext(null);
const STORAGE_KEY = "rf_cart_v1";
// One membership per household — capped in the cart itself so it can never
// even be stacked to 2 before checkout's own one-per-household check runs.
const SINGLE_UNIT_IDS = new Set([LAUNCH_PLAN_ID]);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch {
      return {};
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch {
      /* ignore */
    }
  }, [items]);

  const api = useMemo(() => {
    const setQty = (id, qty) =>
      setItems((prev) => {
        const next = { ...prev };
        if (qty <= 0) delete next[id];
        else next[id] = qty;
        return next;
      });
    return {
      items,
      add: (id) =>
        setItems((p) => ({
          ...p,
          [id]: SINGLE_UNIT_IDS.has(id) ? 1 : (p[id] || 0) + 1,
        })),
      remove: (id) => setQty(id, (items[id] || 0) - 1),
      setQty,
      clear: () => setItems({}),
      count: Object.values(items).reduce((a, b) => a + b, 0),
    };
  }, [items]);

  return <CartContext.Provider value={api}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
